export default __webpack_public_path__ + "static/media/gallery_04.887b7d52.jpg";